import { styled } from "@mui/material/styles";
import { Paper } from "@mui/material";
import Box from "@mui/material/Box";
import { mainColor } from "../../constants/colors";

export const LoginContainer = styled(Paper)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "2rem",
    width: "100%",
    maxWidth: "400px",
    boxShadow: theme.shadows[5] || "0px 3px 6px rgba(0,0,0,0.16)",
    [theme.breakpoints.down("sm")]: {
        padding: "1.5rem",
        maxWidth: "90%",
    },
}));

export const Form = styled("form")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
        gap: "0.75rem",
    },
}));

export const StyledBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: mainColor,
    padding: "0 10px",
    "@media (min-width: 600px)": {
        padding: 0,
    },
});